export const translations = {
  fr: {
    brand: {
      name: "Talo Hub",
      tagline: "Votre business, sous contrôle.",
    },
    nav: {
      home: "Accueil",
      about: "À propos",
      benefits: "Bénéfices",
      pricing: "Offres",
      legal: "Centre légal",
      language: "Langue",
      openMenu: "Ouvrir le menu",
      french: "Français",
      english: "English",
      signup: "S'inscrire",
    },
    footer: {
      description:
        "Talo est une plateforme de gestion moderne permettant de gérer les ventes, le stock, la facturation et les opérations commerciales en temps réel sur Android, iPhone et Desktop.",
      solutions: "Solutions",
      solutionItems: [
        "Gestion de stock",
        "Facturation intelligente",
        "Suivi des ventes",
        "Synchronisation cloud",
        "Impression Bluetooth",
      ],
      contact: "Contact",
      location: "Kinshasa, RDC",
      contactUs: "Contactez-nous",
      downloadOn: "Télécharger sur",
      windows: "Windows",
      rights: "Tous droits réservés",
      privacy: "Politique de confidentialité",
      terms: "Conditions d'utilisation",
      ctaTitle: "Prêt à commencer ?",
      ctaText: "Créez votre compte et essayez Talo Hub sur mobile ou Windows.",
      signup: "Créer mon compte",
      viewPlans: "Voir les offres",
    },
    contact: {
      title: "Contactez-nous",
      close: "Fermer",
      subtitle: "Une question sur Talo ? Écrivez-nous, nous vous répondrons dès que possible.",
      hintPrefix: "Votre message est envoyé à",
      hintSuffix: "depuis le site.",
      name: "Nom complet",
      namePlaceholder: "Votre nom",
      email: "Adresse e-mail",
      emailPlaceholder: "votre@email.com",
      message: "Message",
      messagePlaceholder: "Votre message...",
      cancel: "Annuler",
      submit: "Envoyer",
      sending: "Envoi…",
      success: "Message envoyé. Nous vous répondrons bientôt.",
      error: "Envoi impossible. Réessayez plus tard.",
      captchaRequired: "Complétez la vérification anti-bot.",
      captchaLoading: "Chargement de la vérification…",
      subjectPrefix: "Contact Talo —",
      noName: "Sans nom",
      mailBodyName: "Nom",
      mailBodyEmail: "Email",
      mailBodyMessage: "Message",
    },
    hero: {
      title: "Gardez le contrôle total de votre commerce.",
      subtitle:
        "Ventes, stock, facturation et suivi en temps réel, tout est centralisé pour vous aider à mieux décider et augmenter vos profits.",
      helper: "Accédez à votre business partout, à tout moment.",
      ctaPrimary: "Essayer gratuitement",
      ctaSecondary: "Voir les offres",
      imageAlt: "Talo sur ordinateur, tablette et mobile",
      appStoreAria: "Télécharger dans l'App Store",
      appStoreAlt: "Télécharger dans l'App Store",
      playStoreAria: "Disponible sur Google Play",
      playStoreAlt: "Disponible sur Google Play",
      appStoreBadge:
        "https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/fr-fr?size=250x83",
      playStoreBadge:
        "https://play.google.com/intl/en_us/badges/static/images/badges/fr_badge_web_generic.png",
    },
    benefits: {
      title: "Pourquoi choisir Talo Hub ?",
      intro:
        "Talo aide les commerces, pharmacies et entreprises à mieux gérer leurs opérations grâce à une plateforme moderne, rapide et accessible partout.",
      items: [
        {
          icon: "monitoring",
          title: "Suivi en temps réel",
          text: "Consultez vos ventes, mouvements de stock et activités en direct, où que vous soyez, depuis votre téléphone ou ordinateur.",
        },
        {
          icon: "inventory_2",
          title: "Gestion intelligente du stock",
          text: "Évitez les ruptures grâce au suivi automatique des quantités, alertes de faible stock et historique complet des mouvements.",
        },
        {
          icon: "receipt_long",
          title: "Facturation rapide",
          text: "Créez des ventes et imprimez vos reçus via imprimantes Bluetooth en quelques secondes.",
        },
        {
          icon: "cloud_done",
          title: "Synchronisation cloud",
          text: "Toutes vos données sont synchronisées automatiquement entre Android, iPhone et Desktop.",
        },
        {
          icon: "health_and_safety",
          title: "Gestion pharmacie",
          text: "Suivez les dates d'expiration des médicaments et recevez des alertes avant péremption.",
        },
        {
          icon: "admin_panel_settings",
          title: "Contrôle des utilisateurs",
          text: "Gérez les accès des administrateurs, caissiers et employés avec différents niveaux de permissions.",
        },
        {
          icon: "insights",
          title: "Rapports & statistiques",
          text: "Analysez vos performances grâce aux rapports de ventes, bénéfices et produits les plus vendus.",
        },
        {
          icon: "security",
          title: "Sécurité des données",
          text: "Vos données sont protégées avec des accès sécurisés, sauvegardes et isolation par entreprise.",
        },
      ],
    },
    pricing: {
      title: "Nos offres d'abonnement",
      subtitle: "Choisissez le plan adapté à votre activité.",
      perMonth: "/mois",
      promo: "Offre promotionnelle",
      popular: "POPULAIRE",
      start: "Commencer",
      choosePremium: "Choisir Premium",
      contactUs: "Nous contacter",
      plans: {
        standard: {
          name: "Standard",
          oldPrice: "25,000 FC",
          price: "20,000 FC",
          features: [
            "1 business",
            "Stock simple",
            "Ventes & caisse",
            "Impression Bluetooth",
            "Rapports de base",
            "1–2 utilisateurs",
          ],
          whatsapp:
            "Bonjour je veux m'abonner au plan Standard Talo",
        },
        premium: {
          name: "Premium",
          oldPrice: "60,000 FC",
          price: "45,000 FC",
          features: [
            "Tout Standard +",
            "Multi-utilisateurs",
            "Synchronisation cloud",
            "Historique avancé",
            "Alertes stock (faible stock, expiration)",
            "Gestion de la pharmacie",
            "Support prioritaire",
          ],
          whatsapp: "Bonjour je veux le plan Premium Talo",
        },
        enterprise: {
          name: "Enterprise",
          oldPrice: "120,000 FC",
          price: "90,000 FC",
          features: [
            "Tout Premium +",
            "Multi-branches",
            "Statistiques détaillées des ventes",
            "Accès administrateurs multiples",
            "Sauvegardes avancées",
            "Support dédié",
            "Personnalisation entreprise",
          ],
          whatsapp:
            "Bonjour je veux le plan Enterprise Talo pour mon entreprise",
        },
      },
    },
    signup: {
      title: "Créer votre compte",
      formIntro: "Remplissez le formulaire pour démarrer votre essai gratuit.",
      panelKicker: "Talo Hub",
      panelTitle: "Votre business, sous contrôle.",
      panelText:
        "Ventes, stock, facturation et suivi en temps réel sur Android, iPhone et Windows.",
      panelPoints: [
        "Essai gratuit pour démarrer rapidement",
        "Synchronisation cloud entre vos appareils",
        "Caisse, stock et rapports au même endroit",
      ],
      interestLabel: "Offre choisie",
      trialLabel: "Essai",
      businessName: "Nom du commerce",
      businessNamePlaceholder: "Ex. Pharmacie du Centre",
      category: "Type d'activité",
      categoryPlaceholder: "Sélectionnez un type",
      categoryOptions: {
        Pharmacie: "Pharmacie",
        Boutique: "Boutique",
        Restaurant: "Restaurant",
        Fastfood: "Fastfood",
        "Bar/Terrasse": "Bar / Terrasse",
        Hotel: "Hôtel",
        "Commerce général": "Commerce général",
      },
      country: "Pays du commerce",
      countryHint: "Devise de base : {{currency}} (vous pourrez ajuster le taux plus tard)",
      countryPickerTitle: "Pays du commerce",
      countryPickerClose: "Annuler",
      countrySearch: "Rechercher un pays",
      countryEmpty: "Aucun pays trouvé.",
      countrySelectionPrefix: "Sélection :",
      countrySectionHome: "République démocratique du Congo",
      countrySectionNeighbors: "Voisins de la RD Congo (9)",
      countrySectionAfrica: "Autres pays d’Afrique subsaharienne",
      countrySectionAsia: "Asie",
      address: "Adresse du commerce",
      addressPlaceholder: "Rue, ville…",
      addressHint: "Adresse du premier point de vente (optionnel).",
      login: "Identifiant de connexion",
      loginShortPlaceholder: "pharmacie",
      loginHint: "Le préfixe admin@ est obligatoire. Code court :",
      loginInvalid: "Code court invalide (lettres/chiffres, ex. pharmacie).",
      loginChecking: "Vérification de la disponibilité…",
      loginTaken: "Cet identifiant est déjà utilisé. Choisissez-en un autre.",
      email: "E-mail de contact",
      emailPlaceholder: "vous@email.com",
      emailHint:
        "Nous y envoyons un lien de confirmation. La connexion à l’app se fait avec l’identifiant ci-dessus.",
      password: "Mot de passe",
      passwordPlaceholder: "Au moins 8 caractères",
      passwordConfirm: "Confirmer le mot de passe",
      passwordConfirmPlaceholder: "Retapez le mot de passe",
      showPassword: "Afficher le mot de passe",
      hidePassword: "Masquer le mot de passe",
      passwordMismatch: "Les mots de passe ne correspondent pas.",
      passwordShort: "Le mot de passe doit contenir au moins 8 caractères.",
      passwordWeak:
        "Le mot de passe doit contenir au moins une lettre et un chiffre.",
      passwordHint: "Minimum 8 caractères, avec au moins une lettre et un chiffre.",
      captchaRequired: "Complétez la vérification anti-bot.",
      captchaLoading: "Chargement de la vérification…",
      captchaDevNote:
        "Captcha non configuré. Ajoutez TURNSTILE_SITE_KEY (+ TURNSTILE_SECRET_KEY) dans Supabase Edge Function secrets, puis redéployez talo-self-register.",
      submit: "Créer mon compte",
      submitting: "Création en cours…",
      genericError: "Inscription impossible. Réessayez.",
      legalPrefix: "En créant un compte, vous acceptez notre",
      legalLink: "politique de confidentialité",
      successTitle: "Compte créé",
      successBody:
        "Votre commerce est prêt. Téléchargez l'application et connectez-vous avec votre identifiant et mot de passe.",
      pendingTitle: "Confirmez votre e-mail",
      pendingBody:
        "Nous vous avons envoyé un lien de confirmation. Ouvrez-le pour activer votre compte (valide 24 h). Ensuite téléchargez l’application.",
      pendingEmailSent:
        "Vérifiez votre boîte de réception (et les spams) pour le lien d’activation.",
      pendingEmailSkipped:
        "L’e-mail de confirmation n’a pas pu être confirmé côté serveur. Réessayez ou contactez le support.",
      successLoginPrefix: "Identifiant de connexion :",
      emailSent:
        "Un e-mail de bienvenue vous a été envoyé avec les liens de téléchargement.",
      emailSkipped:
        "Votre compte est actif. Vous pouvez vous connecter immédiatement dans l'application.",
      backHome: "Retour à l'accueil",
    },
    verifyEmail: {
      stepLabel: "Activation du compte",
      loadingTitle: "Activation Talo Hub…",
      loadingBody: "Nous vérifions votre lien de confirmation.",
      missingTitle: "Lien manquant",
      missingBody: "Ce lien d’activation est incomplet. Recommencez l’inscription.",
      errorTitle: "Activation impossible",
      genericError: "Lien invalide ou expiré.",
      retrySignup: "Recommencer l’inscription",
      successTitle: "Compte Talo Hub activé",
      successBody:
        "Votre commerce est prêt. Téléchargez l’application Talo Hub et connectez-vous avec votre identifiant et mot de passe.",
      downloadLabel: "Télécharger Talo Hub",
    },
  },
  en: {
    brand: {
      name: "Talo Hub",
      tagline: "Your business, under control.",
    },
    nav: {
      home: "Home",
      about: "About",
      benefits: "Benefits",
      pricing: "Plans",
      legal: "Legal center",
      language: "Language",
      openMenu: "Open menu",
      french: "Français",
      english: "English",
      signup: "Sign up",
    },
    footer: {
      description:
        "Talo is a modern management platform for sales, inventory, invoicing, and business operations in real time on Android, iPhone, and Desktop.",
      solutions: "Solutions",
      solutionItems: [
        "Inventory management",
        "Smart invoicing",
        "Sales tracking",
        "Cloud sync",
        "Bluetooth printing",
      ],
      contact: "Contact",
      location: "Kinshasa, DRC",
      contactUs: "Contact us",
      downloadOn: "Download on",
      windows: "Windows",
      rights: "All rights reserved",
      privacy: "Privacy policy",
      terms: "Terms of use",
      ctaTitle: "Ready to get started?",
      ctaText: "Create your account and try Talo Hub on mobile or Windows.",
      signup: "Create my account",
      viewPlans: "View plans",
    },
    contact: {
      title: "Contact us",
      close: "Close",
      subtitle: "Have a question about Talo? Write to us and we'll get back to you as soon as possible.",
      hintPrefix: "Your message is sent to",
      hintSuffix: "from this website.",
      name: "Full name",
      namePlaceholder: "Your name",
      email: "Email address",
      emailPlaceholder: "you@email.com",
      message: "Message",
      messagePlaceholder: "Your message...",
      cancel: "Cancel",
      submit: "Send",
      sending: "Sending…",
      success: "Message sent. We'll get back to you soon.",
      error: "Could not send. Please try again later.",
      captchaRequired: "Please complete the anti-bot check.",
      captchaLoading: "Loading verification…",
      subjectPrefix: "Talo contact —",
      noName: "No name",
      mailBodyName: "Name",
      mailBodyEmail: "Email",
      mailBodyMessage: "Message",
    },
    hero: {
      title: "Stay in full control of your business.",
      subtitle:
        "Sales, inventory, invoicing, and real-time tracking — everything is centralized to help you make better decisions and grow your profits.",
      helper: "Access your business anywhere, anytime.",
      ctaPrimary: "Try for free",
      ctaSecondary: "View plans",
      imageAlt: "Talo on desktop, tablet, and mobile",
      appStoreAria: "Download on the App Store",
      appStoreAlt: "Download on the App Store",
      playStoreAria: "Get it on Google Play",
      playStoreAlt: "Get it on Google Play",
      appStoreBadge:
        "https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83",
      playStoreBadge:
        "https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png",
    },
    benefits: {
      title: "Why choose Talo Hub?",
      intro:
        "Talo helps shops, pharmacies, and businesses manage their operations with a modern, fast platform accessible everywhere.",
      items: [
        {
          icon: "monitoring",
          title: "Real-time tracking",
          text: "View your sales, stock movements, and activity live — from your phone or computer, wherever you are.",
        },
        {
          icon: "inventory_2",
          title: "Smart inventory management",
          text: "Avoid stockouts with automatic quantity tracking, low-stock alerts, and a full movement history.",
        },
        {
          icon: "receipt_long",
          title: "Fast invoicing",
          text: "Create sales and print receipts via Bluetooth printers in seconds.",
        },
        {
          icon: "cloud_done",
          title: "Cloud sync",
          text: "All your data syncs automatically across Android, iPhone, and Desktop.",
        },
        {
          icon: "health_and_safety",
          title: "Pharmacy management",
          text: "Track medication expiry dates and receive alerts before products expire.",
        },
        {
          icon: "admin_panel_settings",
          title: "User access control",
          text: "Manage admin, cashier, and staff access with different permission levels.",
        },
        {
          icon: "insights",
          title: "Reports & analytics",
          text: "Analyze performance with sales reports, profit insights, and best-selling products.",
        },
        {
          icon: "security",
          title: "Data security",
          text: "Your data is protected with secure access, backups, and per-business isolation.",
        },
      ],
    },
    pricing: {
      title: "Our subscription plans",
      subtitle: "Choose the plan that fits your business.",
      perMonth: "/month",
      promo: "Promotional offer",
      popular: "POPULAR",
      start: "Get started",
      choosePremium: "Choose Premium",
      contactUs: "Contact us",
      plans: {
        standard: {
          name: "Standard",
          oldPrice: "25,000 FC",
          price: "20,000 FC",
          features: [
            "1 business",
            "Basic inventory",
            "Sales & POS",
            "Bluetooth printing",
            "Basic reports",
            "1–2 users",
          ],
          whatsapp: "Hello, I would like to subscribe to the Talo Standard plan",
        },
        premium: {
          name: "Premium",
          oldPrice: "60,000 FC",
          price: "45,000 FC",
          features: [
            "Everything in Standard +",
            "Multi-user",
            "Cloud sync",
            "Advanced history",
            "Stock alerts (low stock, expiry)",
            "Pharmacy management",
            "Priority support",
          ],
          whatsapp: "Hello, I would like the Talo Premium plan",
        },
        enterprise: {
          name: "Enterprise",
          oldPrice: "120,000 FC",
          price: "90,000 FC",
          features: [
            "Everything in Premium +",
            "Multi-branch",
            "Detailed sales statistics",
            "Multiple admin access",
            "Advanced backups",
            "Dedicated support",
            "Business customization",
          ],
          whatsapp: "Hello, I would like the Talo Enterprise plan for my company",
        },
      },
    },
    signup: {
      title: "Create your account",
      formIntro: "Fill in the form to start your free trial.",
      panelKicker: "Talo Hub",
      panelTitle: "Your business, under control.",
      panelText:
        "Sales, inventory, invoicing, and live tracking on Android, iPhone, and Windows.",
      panelPoints: [
        "Free trial to get started quickly",
        "Cloud sync across your devices",
        "POS, stock, and reports in one place",
      ],
      interestLabel: "Selected plan",
      trialLabel: "Trial",
      businessName: "Business name",
      businessNamePlaceholder: "e.g. Central Pharmacy",
      category: "Business type",
      categoryPlaceholder: "Select a type",
      categoryOptions: {
        Pharmacie: "Pharmacy",
        Boutique: "Shop",
        Restaurant: "Restaurant",
        Fastfood: "Fast food",
        "Bar/Terrasse": "Bar / Terrace",
        Hotel: "Hotel",
        "Commerce général": "General retail",
      },
      country: "Business country",
      countryHint: "Base currency: {{currency}} (you can adjust the rate later)",
      countryPickerTitle: "Business country",
      countryPickerClose: "Cancel",
      countrySearch: "Search a country",
      countryEmpty: "No country found.",
      countrySelectionPrefix: "Selected:",
      countrySectionHome: "Democratic Republic of the Congo",
      countrySectionNeighbors: "DRC neighbors (9)",
      countrySectionAfrica: "Other sub-Saharan African countries",
      countrySectionAsia: "Asia",
      address: "Business address",
      addressPlaceholder: "Street, city…",
      addressHint: "First point of sale address (optional).",
      login: "Login ID",
      loginShortPlaceholder: "pharmacy",
      loginHint: "The admin@ prefix is required. Short code:",
      loginInvalid: "Invalid short code (letters/numbers, e.g. pharmacy).",
      loginChecking: "Checking availability…",
      loginTaken: "This login ID is already taken. Choose another one.",
      email: "Contact email",
      emailPlaceholder: "you@email.com",
      emailHint:
        "We send a confirmation link here. App login uses the ID above.",
      password: "Password",
      passwordPlaceholder: "At least 8 characters",
      passwordConfirm: "Confirm password",
      passwordConfirmPlaceholder: "Re-enter password",
      showPassword: "Show password",
      hidePassword: "Hide password",
      passwordMismatch: "Passwords do not match.",
      passwordShort: "Password must be at least 8 characters.",
      passwordWeak: "Password must include at least one letter and one number.",
      passwordHint: "At least 8 characters, with one letter and one number.",
      captchaRequired: "Complete the anti-bot check.",
      captchaLoading: "Loading verification…",
      captchaDevNote:
        "Captcha not configured. Set TURNSTILE_SITE_KEY (+ TURNSTILE_SECRET_KEY) in Supabase Edge Function secrets, then redeploy talo-self-register.",
      submit: "Create my account",
      submitting: "Creating account…",
      genericError: "Registration failed. Please try again.",
      legalPrefix: "By creating an account, you agree to our",
      legalLink: "privacy policy",
      successTitle: "Account created",
      successBody:
        "Your business is ready. Download the app and sign in with your login ID and password.",
      pendingTitle: "Confirm your email",
      pendingBody:
        "We sent a confirmation link. Open it to activate your account (valid 24h), then download the app.",
      pendingEmailSent:
        "Check your inbox (and spam) for the activation link.",
      pendingEmailSkipped:
        "The confirmation email could not be confirmed by the server. Retry or contact support.",
      successLoginPrefix: "Login ID:",
      emailSent: "A welcome email was sent with the download links.",
      emailSkipped:
        "Your account is active. You can sign in right away in the app.",
      backHome: "Back to home",
    },
    verifyEmail: {
      stepLabel: "Account activation",
      loadingTitle: "Activating Talo Hub…",
      loadingBody: "We are verifying your confirmation link.",
      missingTitle: "Missing link",
      missingBody: "This activation link is incomplete. Please sign up again.",
      errorTitle: "Activation failed",
      genericError: "Invalid or expired link.",
      retrySignup: "Start registration again",
      successTitle: "Talo Hub account activated",
      successBody:
        "Your business is ready. Download the Talo Hub app and sign in with your login ID and password.",
      downloadLabel: "Download Talo Hub",
    },
  },
};
